import axiosClient from "../../api/axiosClient";
import customNotification from "../../components/notification";
import moment from "moment";

const requestWithdrawModel = {
    state: [],
    reducers: {
        setData(state, payload) {
            return { ...state, [payload.name]: payload.data,...payload };
        },
    },
    effects: (dispatch) => ({
        async addWithdrawData(payload) {
            await axiosClient.post('/content/up_withdrawals', payload).then(res => {
                if (res.data.status === 200) {
                    // getBalanceData(payload)
                    this.getWithdrawDataShow(payload)
                    customNotification(res.data.message, "success")
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        },
        async getWithdrawDataShow(payload) {
            await axiosClient.post('/content/withdrawals', payload).then(res => {
                if (res.data.status === 200) {
                   this.setData({ name: "withdraw", data: res.data });
                } else {
                    customNotification(res.data.message, "info")
                }
            }).catch(err => {
                customNotification(err.message, "error")
            })
        }
    }),
};

export default requestWithdrawModel;